import { Grid } from '@mui/material'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import {
  getConsultationsByWeekByEtablissement,
  getPatientsByWeekByEtablissement,
  getRankConsultationsCountByEtablissement,
  selectConsultationStatistics,
  selectPatientStatistics,
} from '@/redux/reducers/statistic.reducer'
import { useAppDispatch, useAppSelector } from '@/redux/rootReducer'
import CountByWeekComponent from '@/components/ui/charts/WeeklyBarChart'
import RankCountComponent from '@/components/ui/charts/RankCount'
import * as form from './FormEmailContainer'
import Button from '@mui/material/Button'
import { Periodicity } from '@/core/api/statistics'
import WeeklyBarChart from '@/components/ui/charts/WeeklyBarChart'
import { useGetEstablishmentConsultationsStatisticsQuery, useGetEstablishmentPatientsStatisticsQuery } from '@/core/services/statistics'

export function StatsContainer() {
  const dispatch = useAppDispatch()
  const { t } = useTranslation()

  const _consultationsStatistics = useAppSelector(selectConsultationStatistics)

  const { consultationsStatistics } = useGetEstablishmentConsultationsStatisticsQuery(
    {
      establishment: 'all',
      periodicity: [Periodicity.WEEKLY],
    },
    {
      selectFromResult: ({ data }) => ({
        consultationsStatistics: {
          labels: data?.periodicity?.WEEKLY?.chart.labels.map((label) => t('page.superAdmin.statistics.consultations.legend', { weekNumber: label })) ?? [],
          datasets: data?.periodicity?.WEEKLY?.chart.datasets ?? [],
        },
      }),
    }
  )

  const { patientsStatistics } = useGetEstablishmentPatientsStatisticsQuery('all', {
    selectFromResult: ({ data }) => ({
      patientsStatistics: {
        labels: data?.chart.labels.map((label) => t('page.superAdmin.statistics.patients.legend', { weekNumber: label })) ?? [],
        datasets: data?.chart.datasets ?? [],
      },
    }),
  })

  const [openEmailDialog, setOpenEmailDialog] = useState<boolean>(false)

  useEffect(() => {
    dispatch(getRankConsultationsCountByEtablissement({ establishmentId: 'all' }))
    dispatch(getConsultationsByWeekByEtablissement({ establishmentId: 'all' }))
    dispatch(getPatientsByWeekByEtablissement({ establishmentId: 'all' }))
  }, [dispatch])

  return (
    <>
      <Grid container spacing={3} marginBottom={3}>
        <Grid item xs={12} md={6}>
          <RankCountComponent data={_consultationsStatistics.rank} title={t('page.superAdmin.statistics.consultations.rank')} />
        </Grid>

        <Grid item xs={12} md={6}>
          <WeeklyBarChart
            chartData={consultationsStatistics}
            title={t('page.superAdmin.statistics.consultations.weekly')}
            label={t('page.superAdmin.statistics.consultations.weekly')}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <WeeklyBarChart chartData={patientsStatistics} title={t('page.superAdmin.statistics.patients.weekly')} label={t('page.superAdmin.statistics.patients.weekly')} />
        </Grid>
      </Grid>
      <Button variant="contained" color="primary" onClick={() => setOpenEmailDialog(true)}>
        Recevoir les stastistiques par mail
      </Button>
      <form.FormEmail onClose={() => setOpenEmailDialog(false)} open={openEmailDialog} />
    </>
  )
}
